<template>
  <swiper
    :effect="'fade'"
    :modules="modules"
    :autoplay="{
      delay: 2000,
    }"
    :speed="2000"
    :loop="true"
  >
    <!-- o preload da 1ª imagem está no <head> da home (pages/[language]/index.vue);
         este carrossel só monta depois da busca do cliente -->
    <swiper-slide v-for="(item, index) in props.cardImages" :key="index">
      <picture>
        <img
          :class="opac"
          id="cover-image"
          :width="isMobile() ? 350 : 1440"
          :height="isMobile() ? 250 : 715"
          :src="item"
          :alt="props.imageAlt || props.modelName"
          :fetchpriority="index == 0 ? 'high' : 'low'"
        />
      </picture>
    </swiper-slide>
  </swiper>
</template>
<script lang="ts" setup>
import { isMobile } from "@/shared/utils/mobile";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";

// import required modules
import { EffectFade, Autoplay } from "swiper/modules";

const props = defineProps(["cardImages", "modelName", "imageAlt"]);

const modules = [EffectFade, Autoplay];

const opac = ref("opacity-0");
onMounted(() => {
  opac.value = "opacity-1";
});
</script>

<style scoped lang="css">
.cover__image img {
  width: 100%;
  height: auto;
}
</style>
